import { createSelector } from 'reselect';

export const getCommon = (state) => state.common;

export const getSpinner = createSelector(getCommon, (common) => common.spinner);

export const getCommonError = createSelector(
  getCommon,
  (common) => common.error
);
